import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const userActions = {
  login,
  loginWToken,
  logout,
  register,
  update,
  forgotPassword,
  changePassword,
  getAll,
  delete: _delete,
  deleteAccount,
  sendMessage
};

function login(email, password, first_name = 0, last_name = 0, cabinet = [], favorites = [], keyIngredients = [], _id = '', editProfile = false) {
  return dispatch => {
    dispatch(request({ email }));
    userService.login(email, password, first_name, last_name, cabinet, favorites, keyIngredients, _id)
      .then(
        user => {

      history.push('/');
    dispatch(success(user));
    if (editProfile) {
      dispatch(alertActions.success('Profile updated successfully.'));
    } else if (first_name) {
      dispatch(alertActions.success('Registration successful.  You are now logged into Fix-a-Drink.'));
      dispatch(registerSuccess(user));
    } else {
      dispatch(success(user));
    }
  },
    error => {
      if (editProfile) {
        dispatch(registerFailure(error));
      } else if (first_name) {
        dispatch(registerFailure(error));
      } else {
        dispatch(failure(error));
      }
      dispatch(alertActions.error(error == 'Conflict' ? "Email already exists." : error));
    }
  );
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }

  function registerRequest(user) { return { type: userConstants.REGISTER_REQUEST, user } }
  function registerSuccess(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
  function registerFailure(error) { console.log("What can I do with this?" , error); return { type: userConstants.REGISTER_FAILURE, error } }
}


function loginWToken(token) {
  return dispatch => {
    dispatch(request());
    userService.loginWToken(token)
      .then(
        user => {

      history.push('/change_password');
    dispatch(success(user));
    dispatch(alertActions.success('Enter a new password.'));

  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function forgotPassword(email) {
  return dispatch => {
    dispatch(request(email));

    userService.forgotPassword(email)
      .then(
        user => {
      dispatch(success());
    history.push('/');
    dispatch(alertActions.success('Further instructions have been sent to your e-mail address.'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request() { return { type: userConstants.FORGOTPASSWORD_REQUEST } }
  function success() { return { type: userConstants.FORGOTPASSWORD_SUCCESS } }
  function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function register(user) {
  let login_next = {email_login: user.email, password_login: user.password};
  return dispatch => {
    dispatch(request(user));

    userService.register(user)
      .then(
        user => {
      dispatch(success(user));
    history.push('/');
    dispatch(alertActions.success('Registration successful'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
  function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function update(user, displayAlertSuccess = true, customMessage = null) {

  return dispatch => {
    dispatch(request(user));

    if (user.first_name == "Guest") {
      let updatedUser = {};
      updatedUser.user = user;
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('user', JSON.stringify(updatedUser));

      if (customMessage) {
        dispatch(alertActions.addToBarSuccess(customMessage));
      }

    } else {
      userService.update(user)
        .then(
          user => {
        dispatch(success(user));
      history.push('/');
      if (displayAlertSuccess) {
        dispatch(alertActions.success('Profile save successful'));
      } else if (customMessage) {
        dispatch(alertActions.addToBarSuccess(customMessage));
      }
    },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
    }

  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function changePassword(user) {

  return dispatch => {
    dispatch(request(user));

    userService.changePassword(user)
      .then(
        user => {
      dispatch(success(user));
    history.push('/');
    dispatch(alertActions.success('Password Changed successfully'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function getAll() {
  return dispatch => {
    dispatch(request());

    /*
     IF YOU UNCOMENT THE FOLLOWING, THE GET ALL USER API WILL ONLY BE CALLED once every 1000 seconds!
     let users_object = {}
     let now = Math.floor(Date.now() / 1000);
     if (localStorage.getItem('users_object')) {
     users_object = JSON.parse(localStorage.getItem('users_object'));
     }
     if ((Object.keys(users_object).length === 0 && users_object.constructor === Object) || (now - users_object.updated > 100)) { // 86400
     */
    userService.getAll()
      .then(
        users => {localStorage.setItem('users_object', JSON.stringify({updated: Math.floor(Date.now() / 1000), users}));dispatch(success(users));},
    error => dispatch(failure(error))
  );
    /*
     } else {

     dispatch(success(users_object.users))
     }
     */
  }

  function request() { return { type: userConstants.GETALL_REQUEST } }
  function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
  function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function deleteAccount(_id) {
  return dispatch => {
    dispatch(request(_id));

    userService.delete(_id)
      .then(
        user => {
      dispatch(success(_id));
    logout();
    history.push('/');
    dispatch(alertActions.success('Successfully deleted user account!'));
  },
    error => {
      dispatch(failure(_id, error));
    }
  );
  };

  function request(_id) { return { type: userConstants.DELETE_ACCOUNT_REQUEST, _id } }
  function success(_id) { return { type: userConstants.DELETE_ACCOUNT_SUCCESS, _id } }
  function failure(_id, error) { return { type: userConstants.DELETE_ACCOUNT_FAILURE, _id, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(_id) {
  return dispatch => {
    dispatch(request(_id));

    userService.delete(_id)
      .then(
        user => {
      dispatch(success(_id));
  },
    error => {
      dispatch(failure(_id, error));
    }
  );
  };

  function request(_id) { return { type: userConstants.DELETE_REQUEST, _id } }
  function success(_id) { return { type: userConstants.DELETE_SUCCESS, _id } }
  function failure(_id, error) { return { type: userConstants.DELETE_FAILURE, _id, error } }
}

function sendMessage(contactFormFields) {
  return dispatch => {
    dispatch(request(contactFormFields));

    userService.sendMessage(contactFormFields)
      .then(
        user => {
      dispatch(success(contactFormFields));
    dispatch(alertActions.success('Message successfully sent!'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(contactFormFields) { return { type: userConstants.SEND_REQUEST, contactFormFields } }
  function success(contactFormFields) { return { type: userConstants.SEND_SUCCESS, contactFormFields } }
  function failure(error) { return { type: userConstants.SEND_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/user.actions.js